const jaundiceProcessor=(element)=>
{
let assembledElement=""

if (element["Pain:"] !== "")
    {
    assembledElement +=`  ${element["Pain:"].toLowerCase()}`
    }

assembledElement += " jaundice"

if (element["Duration:"] !== "")
{
assembledElement += ` for several ${element["Duration:"].toLowerCase()}`
}

if (element["Urine:"] !== ""||  element["Stools:"] !== "")
    {
    assembledElement += " with"
    }

if (element["Urine:"] !== "")
    {
    assembledElement += ` ${element["Urine:"].toLowerCase()} urine`
    }

if (element["Urine:"] !== "" &&  element["Stools:"] !== "")
    {
    assembledElement += " and"
    }

if (element["Stools:"] !== "")
    {
    assembledElement += ` ${element["Stools:"].toLowerCase()} stools`
    }



if (element["Alcohol_Excess:"] !== "" || element["IV_drug_abuse:"] !== "" || element["Foreign_Travel:"] !== "")
    {
    assembledElement += ". They report"
    let featureList = []
    const possibleFeatures=["Alcohol_Excess:", "IV_drug_abuse:", "Foreign_Travel:"]
    possibleFeatures.forEach ((feature)=>
        {
        if (element[feature] !== "")
            {
            featureList.push(feature)
            }
        })
        let featureCount=featureList.length

        featureList.forEach((describedFeature)=>
            {
            if (element[describedFeature] === "No")
                {
                assembledElement +=  " no " 
                }
            else
                {
                assembledElement +=  " a history of "   
                }
            assembledElement += describedFeature.toLowerCase().replaceAll("_", " ").replace(":", "")
            
            switch (featureCount)
                {
                case 1:  assembledElement += ". "
                break

                case 2:  assembledElement += " and "
                break

                default:
                    assembledElement += ", "
                }
            featureCount --
            
            })
     
        }
    
return (assembledElement)
}

export default jaundiceProcessor